import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { MenuOutlined } from '@ant-design/icons';
import { Layout } from 'antd';
import { isChrome } from '../../services/helper/browser';
/* import { SINGLE_PAGE_LAYOUT } from '../../constants/layoutConstants'; */
import { clearCCCStatus } from '../CCC/store/action';
import { changeLeft, changeTop } from "../panelStore/action";
import { closeTabFooter, openTabFooter, cleanTabMonitorStatus } from '../MonitorStore/action';
import DelConfirm from '@/components/DelConfirm';
import SideFooter from '@/components/SideFooter';
import Line from '@/components/Line';
import { HIMALAYAS } from '../../constants/pageType';
import { setPageType } from '../../pages/Login/action';
import { updatePageLayout, updatePCBLayout } from './store/project/action';
import { changeProduct } from '../LayoutExplorer/LayoutStore/action';
import HimalayasSider from './HimalayasSider';
import HimalayasContent from './Content';
import '@/publicCss/style.css';
import '@/publicCss/tree.css';
import '@/publicCss/libraryStyle.css';
import '@/publicCss/aurora.css';
import '@/publicCss/auroraContent.css';
import '@/publicCss/extraction.css';
import './index.css';

const { Content } = Layout;
const errorMsg = 'Non Chrome browser is not supported in the simulation platform.';

class HimalayasPage extends Component {
  constructor(props) {
    super(props);
    this.version = props.version;
    this.servicesAccount = props.servicesAccount;
    this.state = {
      width: 280,
      linePosition: {
        position: "absolute",
        left: 280
      },
      openMenu: true,
      chrome: true,
      browserVisible: false
    }
  }

  componentWillMount() {
    //clear CCC status
    this.props._clearCCCStatus();
    this.props.setPageType(HIMALAYAS);
  }

  changeWidth(width) {
    let position = {
      position: "absolute",
      left: width,
      minWidth: 56,
      maxWidth: 1000
    }
    this.setState({
      linePosition: position,
      width
    })
    //page left sider
    this.props._changeLeft(width);
  }

  componentDidMount = () => {
    //page left sider
    this.props._changeLeft(280);
    //page top menu
    this.props._changeTop(54);
    //clear monitor reducer
    this.props._cleanTabMonitorStatus();
    this.props.changeProduct(HIMALAYAS);
    const chrome = isChrome();
    this.setState({
      chrome,
      browserVisible: chrome ? false : true
    })
  }

  componentDidUpdate = (prevProps) => {
    const { pageType } = this.props;
    if (pageType !== prevProps.pageType) {
      //switch product, clear monitor reducer
      this.props._cleanTabMonitorStatus();
    }
  }

  changeSize = (width) => {
    let newWidth = width;
    const prevWidth = this.state.width;
    if (prevWidth === 56 && width > 56) {
      this.setState({
        openMenu: true
      });
      newWidth = 255;
      this.changeWidth(newWidth);
    } else {
      width = width < 255 ? 56 : width;
      width = width > 1000 ? 1000 : width;
      if (width === 56) {
        this.setState({
          openMenu: false
        });
      }
      this.changeWidth(width);
    }
  }

  openMenu = (e) => {
    e.stopPropagation();
    this.setState({
      openMenu: true,
      width: 255,
      linePosition: {
        position: "absolute",
        left: 255,
        minWidth: 56,
        maxWidth: 1000,
      }
    });
  }

  pcbLayoutChange = (type) => {
    //const { pcbLayout } = this.props;
    //  this.props._updatePCBLayout(type, pcbLayout);
  }

  layoutClick = (layoutType, singleType) => {
    if (singleType) {
      //  this.viewClick(singleType);
      return;
    }
    // this.props._updatePageLayout(layoutType);
  }

  viewClick = (type) => {
    // this.props._updatePageLayout(SINGLE_PAGE_LAYOUT, type);
  }

  changeTabFooter = () => {
    const { _openTabFooter, _closeTabFooter, tabVisible } = this.props;
    tabVisible ? _closeTabFooter() : _openTabFooter();
  }

  render = () => {
    const { width, linePosition, openMenu, chrome, browserVisible } = this.state;
    return (
      <Fragment>
        {chrome ? <Layout className="aurora-layout">
          {/* --- himalayas Sider(left) --- */}
          <div className='aurora-sider'
            style={{ width: width }}
          >
            {openMenu ?
              /* --- himalayas Sider tree(when width is > 56)--- */
              <div className='himalayas-sider-menu-tree aurora-sider-menu-tree'>
                <HimalayasSider siderWidth={width} />
              </div>
              :
              /* --- himalayas Sider icon(when width is < 255)--- */
              <div className='aurora-sider-menu'>
                <MenuOutlined onClick={(e) => this.openMenu(e)} />
              </div>
            }
            {/* --- himalayas Sider footer display icon--- */}
            <SideFooter
              actions={this.sideFooterActions()}
            />
          </div>
          <Line
            //Position is used to locate the Line
            position={linePosition}
            changeWidth={(width) => this.changeWidth(width)}
            width={width}
            resize={this.changeSize}
          />
          {/* --- himalayas Content(right) --- */}
          <Content className='aurora-content' style={{ left: width, overflow: '' }}>
            <HimalayasContent siderWidth={width} />
          </Content>
        </Layout> : null
        }
        {/* isChrome */
          browserVisible ? <DelConfirm
            data={null}
            removeCancel={true}
            deleteConfirm={this.okConfirm}
            message={errorMsg}
          /> : null
        }
      </Fragment>
    );
  }

  sideFooterActions = () => {
    const { openMenu } = this.state;
    const { viewList, tabVisible, layout, openProjectId, pcbLayout } = this.props;
    return {
      openMenu,
      viewList,
      tabVisible,
      layout,
      pcbLayout,
      currentProjectId: openProjectId,
      pcbLayoutChange: this.pcbLayoutChange,
      layoutClick: this.layoutClick,
      changeTabFooter: this.changeTabFooter
    }
  }
}

const mapState = (state) => {
  const { PanelStatus, LoginReducer: { pageType }, HimalayasReducer } = state;
  const { defaultTop, defaultLeft } = PanelStatus;
  const { tabVisible } = state.MonitorInfoReducer;
  const { project: { openProjectId, viewList, layout, pcbLayout } } = HimalayasReducer;
  return {
    pageType,
    defaultTop,
    defaultLeft,
    tabVisible,
    openProjectId,
    viewList,
    layout,
    pcbLayout
  }
}

const mapDispatch = (dispatch) => ({
  _clearCCCStatus() {
    dispatch(clearCCCStatus());
  },
  _changeLeft(width) {
    dispatch(changeLeft(width));
  },
  _changeTop(top) {
    dispatch(changeTop(top));
  },
  _cleanTabMonitorStatus() {
    dispatch(cleanTabMonitorStatus());
  },
  _openTabFooter() {
    dispatch(openTabFooter())
  },
  _closeTabFooter() {
    dispatch(closeTabFooter())
  },
  setPageType(type) {
    dispatch(setPageType(type))
  },
  _updatePageLayout(layout, singleType) {
    dispatch(updatePageLayout(layout, singleType))
  },
  _updatePCBLayout(pcbLayout, prePcbLayout) {
    dispatch(updatePCBLayout(pcbLayout, prePcbLayout))
  },
  changeProduct(product) {
    dispatch(changeProduct(product))
  }
})

export default connect(mapState, mapDispatch)(HimalayasPage);